/* eslint-disable @typescript-eslint/no-non-null-assertion, react/jsx-no-target-blank */
import { IUserSchema, IUserSubscriptionSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { Button } from '@cian/button-component';
import { CheckboxField, Preloader, TextField, Tooltip, VisualSize } from '@cian/components';
import * as React from 'react';
import * as Modal from 'react-modal';

import { isEmail, isFakeEmail } from '../../utils/validate';
import { FLOCKTORY_KEY_EVENT } from '../../utils/flocktory';
import { TStatusFetch } from '../../store/subscription_price_changes_popup/';
import { IconClose } from './icons/icon_close';

export interface ISubscriptionPriceChangesPopupProps {
  error: string;
  isEmailConfirmed: boolean;
  isOpen: boolean;
  offerId: number;
  statusFetch: TStatusFetch;
  subscription: IUserSubscriptionSchema | null;
  user: IUserSchema | null;
  pushSubscribed: boolean;
}

export interface ISubscriptionPriceChangesPopupDispatchProps {
  submitSubscriptionPriceChanges(
    email: string,
    offerId: number,
    isSubscribeNews: boolean,
    isPushSubscribe: boolean,
  ): void;
  submitUnsubscriptionPriceChanges(offerId: number): void;
  subscriptionPriceChangesPopupClose(): void;
}

export type IProps = ISubscriptionPriceChangesPopupProps & ISubscriptionPriceChangesPopupDispatchProps;

export interface ISubscriptionPriceChangesPopupState {
  email: string;
  emailError: string;
  globalError: string;
  isSubscribeNews: boolean;
  isSubscribed: boolean;
  isPushSubscribe: boolean;
}

import * as styles from './index.css';

export class SubscriptionPriceChangesPopup extends React.Component<IProps, ISubscriptionPriceChangesPopupState> {
  public constructor(props: IProps) {
    super(props);

    this.state = {
      email: '',
      emailError: '',
      globalError: '',
      isPushSubscribe: true,
      isSubscribeNews: true,
      isSubscribed: !!(props.subscription && props.subscription.isSubscribed),
    };
  }

  public UNSAFE_componentWillReceiveProps(nextProps: ISubscriptionPriceChangesPopupProps) {
    if (nextProps.error) {
      this.setState({
        globalError: nextProps.error,
      });
    }

    if (nextProps.isOpen) {
      document.body.style.overflow = 'hidden';

      if (nextProps.user && nextProps.user.isAuthenticated && !this.state.email) {
        this.setState({
          email: nextProps.user.email && !isFakeEmail(nextProps.user.email) ? nextProps.user.email : '',
        });
      }
    } else {
      document.body.style.overflow = '';

      this.setState({
        email: '',
        emailError: '',
        globalError: '',
        isSubscribed: !!(nextProps.subscription && nextProps.subscription.isSubscribed),
      });
    }

    /**
     * Отправляем запрос на показ системного попапа разрешения пушей, если:
     *  - статус запроса подписки равен ОК
     *  - у нас есть window.dataLayer
     *  - пользователь подписался на изменение цены
     *  - отмечен чекбок "Подписаться на push-уедомления"
     */
    if (
      this.props.statusFetch !== 'ok' &&
      nextProps.statusFetch === 'ok' &&
      window.dataLayer &&
      this.props.subscription &&
      this.props.subscription.isSubscribed &&
      this.state.isPushSubscribe
    ) {
      window.dataLayer.push({ event: FLOCKTORY_KEY_EVENT });
    }
  }

  public render() {
    return (
      <Modal
        isOpen={this.props.isOpen}
        ariaHideApp={false}
        onRequestClose={this.props.subscriptionPriceChangesPopupClose}
        style={{
          content: {
            overflow: 'visible',
            padding: '0',
            position: 'static',
            width: '500px',
            zIndex: 101,
          },
          overlay: {
            alignItems: 'center',
            backgroundColor: 'rgba(24, 41, 48, 0.8)',
            display: 'flex',
            justifyContent: 'center',
            zIndex: 100,
          },
        }}
      >
        {this.state.isSubscribed ? this.renderUnsubscribeContent() : this.renderSubscribeContent()}
      </Modal>
    );
  }

  private renderSubscribeContent = () => (
    <div className={styles['content']}>
      <div className={styles['title']}>Подписка на изменение цены</div>
      <button className={styles['close']} onClick={this.props.subscriptionPriceChangesPopupClose}>
        <IconClose />
      </button>
      {!this.props.isEmailConfirmed && this.state.isSubscribeNews && this.props.statusFetch === 'ok' ? (
        <div className={styles['description']}>
          Активируйте вашу подписку с помощью ссылки из письма, отправленного на адрес
        </div>
      ) : (
        <div className={styles['description']}>Мы пришлем вам письмо, если цена объекта изменится</div>
      )}
      {this.props.statusFetch === 'ok' ? this.renderSuccessResponse() : this.renderForm()}
    </div>
  );

  private renderUnsubscribeContent = () => (
    <div className={styles['content']}>
      <div className={styles['title']}>Отмена подписки на изменение цены</div>
      <button className={styles['close']} onClick={this.props.subscriptionPriceChangesPopupClose}>
        <IconClose />
      </button>
      <div className={styles['description']}>
        {/* tslint:disable-next-line:no-non-null-assertion */}
        На <strong>{this.props.subscription!.email || 'вашу почту'}</strong> больше не будут приходить письма
      </div>
      {this.props.statusFetch === 'ok' ? this.renderUnsubscribeSuccessResponse() : this.renderUnsubscribeForm()}
    </div>
  );

  private renderUnsubscribeForm = () => (
    <form className={styles['form']} onSubmit={this.handleUnsubscribe}>
      <div className={styles['form_top']}>
        <Button type="submit" theme="default" size="S">
          Отписаться
        </Button>
      </div>
    </form>
  );

  private renderUnsubscribeSuccessResponse = () => (
    <div className={styles['success']}>Вы отписались от уведомлений об изменении цены</div>
  );

  private renderSuccessResponse = () => (
    <div className={styles['success']}>
      {this.state.isSubscribeNews && this.props.statusFetch === 'ok' ? (
        <strong>{this.state.email}</strong>
      ) : (
        <div>
          На <strong>{this.state.email}</strong> оформлена подписка на изменение цены
        </div>
      )}
    </div>
  );

  private renderForm = () => (
    <form className={styles['form']} onSubmit={this.handleSubmit}>
      <div className={styles['form_top']}>
        <div>
          <Tooltip tooltipContent={this.state.emailError || this.state.globalError}>
            <TextField
              invalid={!!this.state.emailError}
              onValueChange={this.changeEmail}
              value={this.state.email}
              placeholder="Ваш email"
              size={VisualSize.SMALL}
            />
          </Tooltip>
        </div>
        <div>
          {this.props.statusFetch === 'isFetching' && (
            <div className={styles['preloader']}>
              <Preloader size={16} />
            </div>
          )}
          <Button type="submit" theme="default" size="S">
            Подписаться
          </Button>
        </div>
      </div>
      <div className={styles['form_bottom']}>
        <div className={styles['form_bottom_checkbock']}>
          <CheckboxField
            label="Хочу получать новости Cian.ru"
            value={this.state.isSubscribeNews}
            onValueChange={this.changeSubscribeNews}
          />
        </div>
        {this.props.pushSubscribed && (
          <div className={styles['form_bottom_checkbock']}>
            <CheckboxField
              label="Включить push-уведомления"
              value={this.state.isPushSubscribe}
              onValueChange={(value: boolean) => this.setState({ isPushSubscribe: value })}
            />
          </div>
        )}
        {this.props.user && !this.props.user.isAuthenticated && (
          <div>
            При подписке вы принимаете условия&nbsp;
            <a href="//www.cian.ru/help/about/rules/" target="_blank">
              Пользовательского соглашения
            </a>{' '}
            и{' '}
            <a href="//www.cian.ru/help/about/36526/" target="_blank">
              Политики конфиденциальности
            </a>
          </div>
        )}
      </div>
    </form>
  );

  private changeEmail = (email: string) => {
    this.setState({
      email,
      emailError: '',
      globalError: '',
    });
  };

  private changeSubscribeNews = (isSubscribeNews: boolean) => {
    this.setState({
      isSubscribeNews,
    });
  };

  private handleUnsubscribe = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    this.props.submitUnsubscriptionPriceChanges(this.props.offerId);
  };

  private handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const email = this.state.email.trim();

    if (!email) {
      this.setState({
        emailError: 'Укажите почту',
      });

      return;
    }

    if (!isEmail(email)) {
      this.setState({
        emailError: 'Неправильный формат почты',
      });

      return;
    }

    this.props.submitSubscriptionPriceChanges(
      email,
      this.props.offerId,
      this.state.isSubscribeNews,
      this.state.isPushSubscribe,
    );
  };
}
